var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vchart',_vm._b({ref:"el",style:(_vm.style),attrs:{"autoresize":"","options":_vm.options,"theme":_vm.theme}},'vchart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }